import React from 'react';
import { Field } from 'formik';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { bool, object } from 'prop-types';

// Import components
import { FirebaseAuthField, SelectField } from 'components/elements';
import CountryFlag from './CountryFlag';

// Import helpers
import { phoneCodes } from 'helpers/phone_codes';
import { AUTH_FIELDS_NAMES } from 'components/views/authentication/login/firebase_auth/helpers';

// Import styles
import { PhoneNumberWrapper } from 'components/views/authentication/login/firebase_auth/style';

const { Option } = Select;

const PhoneNumberFormFields = ({ isSubmitting, values, formRef }) => {
	const { t } = useTranslation();

	return (
		<>
			<Field name={AUTH_FIELDS_NAMES.COUNTRY} component={SelectField}>
				{phoneCodes.map(({ iso2, name }) => (
					<Option key={iso2} value={iso2}>
						{name}
					</Option>
				))}
			</Field>
			<PhoneNumberWrapper>
				<CountryFlag country={values.country} formRef={formRef} />
				<Field
					name={AUTH_FIELDS_NAMES.DIAL_CODE}
					type="text"
					disabled={true}
					component={FirebaseAuthField}
					isDialCodeField={true}
				/>
				<Field
					placeholder={t('common_login_firebase_phone_number_placeholder')}
					name={AUTH_FIELDS_NAMES.PHONE_NUMBER}
					type="number"
					disabled={isSubmitting}
					component={FirebaseAuthField}
					marginBottom="0"
				/>
			</PhoneNumberWrapper>
		</>
	);
};

PhoneNumberFormFields.propTypes = {
	isSubmitting: bool.isRequired,
	values: object.isRequired,
	formRef: object.isRequired
};

export default PhoneNumberFormFields;
